module.exports = __webpack_public_path__ + "eb959d9bbea6f5ee892ce2c7b045fb8d.svg";